import * as React from 'react';
import { ProtectedPageWrapper } from '../designSystem/layouts/pageWrappers/ProtectedPageWrapper';
import { SafetyInspectionListingView } from '../features/activities/SafetyInspection/SafetyInspectionListingView';

export default function SafetyInspectionListingPage(): JSX.Element 
{
	return (
		<ProtectedPageWrapper requiredPermissions={['ViewActivity']} selectedMenuItemKey={'safetyinspection'}>
            <SafetyInspectionListingView />
		</ProtectedPageWrapper>
	);
}